import { IonCol, IonRow } from '@ionic/react';
import React from 'react';
import { useIntl } from 'react-intl';
import { DqText } from '../../../dq-text';
import { JobMessages } from 'src/intl/JobMessages';
import './InformationModals.scss';
import { AppModal } from '../../../reusable-components/app-modal/AppModal';

interface HighPressureModalProps {
  /**
   * Whether the modal is open.
   */
  isOpen: boolean;
  /**
   * Triggers the request to close the modal.
   */
  onClose: () => void;
  /**
   * Triggers the request to close the modal and submit the edit-profile.
   */
}

export const HighPressureModal: React.FC<HighPressureModalProps> = ({ onClose, isOpen }) => {
  const { formatMessage } = useIntl();

  return (
    <AppModal
      isOpen={isOpen}
      title={formatMessage(JobMessages.highPressureHeading)}
      onClose={onClose}
      primaryButton={{
        label: formatMessage(JobMessages.gotItButton),
        onClick: onClose,
      }}
    >
      <IonRow className="info-heading-row">
        <DqText variant="body-strong"> {formatMessage(JobMessages.overviewHeading)}</DqText>
      </IonRow>
      <IonRow className="ion-padding-bottom">
        <DqText variant="body">{formatMessage(JobMessages.highPressureOverviewDescription)}</DqText>
      </IonRow>
      <IonRow className="ion-color-data-blue">
        <IonCol size="1" offset="1">
          <div className="pie-chart-graph-color-key" />
        </IonCol>
        <IonCol size="10">
          <DqText variant="body-strong">{formatMessage(JobMessages.highPressureOverviewLegendOn)}</DqText>
        </IonCol>
      </IonRow>
      <IonRow className="ion-color-data-green">
        <IonCol size="1" offset="1">
          <div className="pie-chart-graph-color-key" />
        </IonCol>
        <IonCol size="10">
          <DqText variant="body-strong">{formatMessage(JobMessages.highPressureOverviewLegendOff)}</DqText>
        </IonCol>
      </IonRow>
      <IonRow className="ion-color-data-orange">
        <IonCol size="1" offset="1">
          <div className="pie-chart-graph-color-key" />
        </IonCol>
        <IonCol size="10">
          <DqText variant="body-strong">{formatMessage(JobMessages.highPressureOverviewLegendControllerOff)}</DqText>
        </IonCol>
      </IonRow>
    </AppModal>
  );
};

export default HighPressureModal;
